module.exports = __webpack_public_path__ + "img/rbc.09531a0d.png";